import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EntityInstanceNode } from "./entity-instance-node/EntityInstanceNode";
import { modalDialogEvent } from "../../../components/SchemaPropertyNode";

import { EntityConfigurationService } from  "../../../entity-services/features/entityConfiguration/entity-configuration.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";


@Component({
  selector: 'app-entity-instance-register-container',
  template: `
<i *ngIf="!isEdit" class="fa fa-plus-square add-entity-icon rightAddbutton" (click)="OpenAddEntityInstance(addEntityInstance)"></i>

<i *ngIf="isEdit" class="fa fa-pencil-square-o edit-entity-icon" (click)="OpenAddEntityInstance(addEntityInstance)"></i>
<!-- Modal for Add Rlation-->
<ng-template #addEntityInstance let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h6 *ngIf="!isEdit" class="modal-title">Add Entity Instance</h6>
    <h6 *ngIf="isEdit" class="modal-title">Edit Entity Instance</h6>
    <button type="button" class="close" aria-label="Close" (click)="onCloseEntityRegiserDialog();d('Cross click');">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <label>Schema Name: </label>
        </div>
        <div class="col-md-4">
          <label>{{entitySchema.title}}</label>
        </div>
      </div>    
      <div class="row">
        <div class="col-md-12">          
          <app-entity-instance-register-editor [root]="rootEntity"></app-entity-instance-register-editor>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-md" (click)="addEntity();c('Close click');">Save</button>   
    <button type="button" class="btn btn-outline-dark btn-md" (click)="onCloseEntityRegiserDialog();c('Close click');">Close</button>     
  </div>
</ng-template>`,
  styles: [`.entityInstance.mat-expansion-panel .mat-expansion-panel-content,.entityInstance.mat-expansion-panel .mat-expansion-panel-content.mat-expanded{display:none!important;height:0!important;visibility:hidden!important}.not-scalar .my-expansion-indicator{visibility:visible!important}.my-expansion-indicator{visibility:hidden!important}.my-expansion-indicator.rotate0degree{border-style:solid;border-width:0 2px 2px 0;content:'';display:inline-block;padding:5px;-webkit-transform:rotate(45deg);transform:rotate(45deg);vertical-align:middle;margin-right:-3px}.my-expansion-indicator.rotate180degree{border-style:solid;border-width:0 0 2px 2px;content:'';display:inline-block;padding:5px;-webkit-transform:rotate(133deg);transform:rotate(133deg);vertical-align:middle;margin-right:2px;margin-top:11px}.mat-expansion-panel{margin-bottom:1px!important;-webkit-transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:box-shadow 280ms cubic-bezier(.4,0,.2,1),-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;-webkit-transition:margin 225ms cubic-bezier(.4,0,.2,1);transition:margin 225ms cubic-bezier(.4,0,.2,1);background:#fff;color:rgba(0,0,0,.87)}.mat-expansion-panel.hidden{display:none!important}.mat-expansion-panel:not([class*=mat-elevation-z]){-webkit-box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-expansion-panel-header{height:48px!important}.mat-expansion-panel-header.mat-expanded.not-scalar,.mat-expansion-panel-header.not-scalar{background:#87ceeb}.mat-expansion-panel-header-title{color:rgba(0,0,0,.87)}.mat-expansion-panel-header.not-scalar .mat-expansion-panel-header-title i.addProperty{display:block}.mat-expansion-panel-header .mat-expansion-panel-header-title i.addProperty{display:none}.mat-expansion-panel-header-title i,.mat-expansion-panel-header-title span{margin-left:5px}.propAttibutes{color:#868989;background-color:#efefef;border-radius:2px;padding:6px 16px;cursor:pointer;font-size:13px;margin-top:10px}.propAttibute{color:#ff9405;margin:5px}.propAttibute input,.propAttibute span{font-family:'Roboto Mono',Menlo,"Bitstream Vera Sans Mono","DejaVu Sans Mono",Monaco,Consolas,monospace}.left-1{margin-left:15px!important}.left-2{margin-left:30px!important}.left-3{margin-left:45px!important}.left-4{margin-left:60px!important}.left-5{margin-left:75px!important}.left-6{margin-left:90px!important}.left-7{margin-left:105px!important}.left-8{margin-left:120px!important}.green-checkbox{-webkit-appearance:none;background-color:#fafafa;border:1px solid #cacece;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);padding:12px 6px 10px 17px;border-radius:3px;display:inline-block;position:relative;margin-bottom:1px;margin-left:7px}.required{color:red}.green-checkbox:active,.green-checkbox:checked:active{-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1)}.green-checkbox:checked{background-color:green;border:1px solid green;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);color:#99a1a7}.entityInstance input[type=text]{border:none;margin-left:9px}.entityInstance input[type=text]:focus,.entityInstance required input[type=text]{background:#ffffe0}`]
})
export class EntityInstanceRegisterContainerComponent implements OnInit {
  @Input() entitySchema: any;
  @Output() saveEntityEvent: EventEmitter<any> = new EventEmitter<any>();
  rootEntity: EntityInstanceNode = new EntityInstanceNode();
  @Input() editableEntity: any;
  @Input() isEdit: boolean;
  selectedTemplate: any;
  constructor(private modalService: NgbModal, private entityConfigService: EntityConfigurationService
    , public toastr: ToastsManager) { }

  ngOnInit() {
    console.log(this.rootEntity);

  }
  OpenAddEntityInstance(content) {
    this.rootEntity.generateInstanceNodeFromSchema(this.entitySchema);
    if (this.isEdit) {
      this.rootEntity.importEntityInstanceNodeFromJsonObject(this.editableEntity);
      this.rootEntity.setIsEditFlag(this.isEdit);
    }
    this.modalService.open(content, { backdrop: "static", size: "lg" });

  }

  addEntity() {
    let entity = this.rootEntity.getEntityInstanceJson();
    entity["type"] = this.entitySchema["title"];
    console.log(entity);
    console.log(JSON.stringify(entity));
    this.entityConfigService.saveEntities([entity]).subscribe(res => {
      this.toastr.success("Entity instance successfully saved", "Success!");
      this.saveEntityEvent.emit(entity);
      this.rootEntity = new EntityInstanceNode();
      this.editableEntity = null;
    }, error => {
      this.toastr.error("Error while saving entity instance", "Error!");
      this.editableEntity = null;
    })

  }
  onCloseEntityRegiserDialog() {
    this.rootEntity = new EntityInstanceNode();
    this.selectedTemplate = null;
  }

}
